import store from '@/store'

export default function entityListsModule() {
  const fetchShows = (list, params = {}, full = true) => {
    if (typeof params === 'object' && typeof params?.q !== 'undefined' && (params?.q.length > 0 && params?.q.length < 3)) {
      return
    }
    const defaultParams = {
      sortBy: 'id', sortDesc: false, page: 1, perPage: 30,
    }
    const queryParams = { ...defaultParams, ...params, full }
    store
      .dispatch('api/fetchShows', { ...queryParams })
      .then(response => response.data)
      .then(response => {
        list.value = []
        response.data.forEach(show => {
          if (isNaN(Number(show.name))) {
            const label = show.name + (show.place ? ` / ${show.place.city_name}` : '')
            list.value.push({ label, value: show.id })
          }
        })
      })
  }
  const fetchOrderLoyaltyTypes = (list, params = {}, full = true) => {
    if (typeof params === 'object' && typeof params?.q !== 'undefined' && (params?.q.length > 0 && params?.q.length < 3)) {
      return
    }
    const defaultParams = {
      sortBy: 'id', sortDesc: false, page: 1, perPage: 30,
    }
    const queryParams = { ...defaultParams, ...params, full }
    store
      .dispatch('widget/fetchOrderLoyaltyTypes', { ...queryParams })
      .then(response => response.data)
      .then(response => {
        list.value = []
        response.data.forEach(loyaltyType => {
          list.value.push({ label: loyaltyType.name, value: loyaltyType.id })
        })
      })
  }
  return {
    fetchShows,
    fetchOrderLoyaltyTypes,
  }
}
